const defs = [
  {
    title: "Avvikelser",
    key: "FAULTS",
    visited: false,
    hasError: false,
    fieldKeys: ["faults"],
  },
  {
    title: "Dokument",
    key: "DOCUMENT",
    visited: true,
    hasError: false,
    fieldKeys: ["completion_files"],
  },
  {
    title: "Kommentar",
    key: "ERRAND",
    visited: true,
    hasError: false,
    fieldKeys: ["completion_comment"],
  },
  {
    title: "Granska och slutför",
    key: "CONFIRM",
    visited: false,
    hasError: false,
    fieldKeys: ["execute_end"],
  },
];

export default () => {
  return defs;
};
